module.exports = __webpack_public_path__ + "static/media/angela-sartori.d8a83431.png";